import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ProductsSection } from './components/ProductsSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { GallerySection } from './components/GallerySection';
import { NoirAtelierPromo } from './components/NoirAtelierPromo';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { NoirAtelierPage } from './pages/NoirAtelierPage';
function HomePage() {
  return <div className="w-full min-h-screen bg-dark-900 text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <ProductsSection data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <GallerySection data-id="element-8" />
        <NoirAtelierPromo data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}
export function App() {
  return <Routes data-id="element-12">
      <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
      <Route path="/noir-atelier" element={<NoirAtelierPage data-id="element-16" />} data-id="element-15" />
    </Routes>;
}